/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.messages.details', [])
    .controller('MessagesDetailsAdminCtrl', MessagesDetailsAdminCtrl);

  /** @ngInject */
  function MessagesDetailsAdminCtrl($scope, $stateParams, UsersService, UploadService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = '';
    vm.sortReverse = false;

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }
      UsersService.listChatsMessages($stateParams.id, vm.oldPage, 25, vm.sortType).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        var messages = result.results;

        for (var i = 0; i < messages.length; i++) {
          if (messages[i]['ts-m'] !== undefined) {
            messages[i]['ts-m'] = new Date(parseInt(messages[i]['ts-m'].toString().substring(0, messages[i]['ts-m'].toString().length - 3)));
          }
        }

        vm.items = _.orderBy(messages, ['ts-m'], ['desc']);
      }
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }

      load(vm.pagination.current);
    };

  }


})();
